import { useTemplateRef as B, ref as i, onMounted as I, withDirectives as N, createElementBlock as S, openBlock as b, withKeys as f, withModifiers as d, renderSlot as A, unref as K } from "vue";
import w from "../../../utils/directives/click-outside.js";
import { getFocusableElements as v } from "../../../utils/functions/focusables.js";
const _ = ["onKeydown"], $ = /* @__PURE__ */ Object.assign({
  name: "DsSelectBoxContainer",
  directives: { clickOutsideAwds: w }
}, {
  __name: "select-box-container",
  props: {
    firstLetterSearch: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["click-outside"],
  setup(x, { emit: h }) {
    const k = h, a = B("container"), y = x, o = i(0), u = i(!1), s = i([]), l = i(0);
    function T(e) {
      if (!u.value || !y.firstLetterSearch || e.key.length > 1)
        return;
      const n = v(a.value).find(
        (t) => (t == null ? void 0 : t.node.innerText.charAt(0).toLowerCase()) === e.key
      );
      n && (o.value = n.index, n.node.focus());
    }
    function p(e) {
      var t;
      const n = e === "up" ? -1 : 1;
      if (s.value = v(a.value), o.value = o.value + n, o.value < l.value && n === -1) {
        o.value = l.value;
        return;
      }
      if (o.value === s.value.length) {
        o.value = o.value - 1;
        return;
      }
      (t = s.value[o.value]) == null || t.node.focus();
    }
    function c(e) {
      u.value && (u.value = !1, r(), (e == null ? void 0 : e.code) === "Escape" && setTimeout(() => {
        m();
      }, 10));
    }
    function g() {
      r(), u.value && m();
    }
    function m() {
      var n, t;
      const e = (t = (n = s.value) == null ? void 0 : n[0]) == null ? void 0 : t.node;
      e.focus(), r(), e.nodeName === "INPUT" && setTimeout(() => {
        e.selectionStart = e.selectionEnd = e.value.length;
      }, 0);
    }
    function E() {
      c(), k("click-outside");
    }
    function O() {
      u.value = !0;
    }
    function r() {
      o.value = 0;
    }
    return I(() => {
      var e, n;
      if (a.value) {
        s.value = v(a.value);
        const t = ((n = (e = s.value) == null ? void 0 : e[0]) == null ? void 0 : n.node) || null;
        l.value = (t == null ? void 0 : t.nodeName) === "BUTTON" ? 1 : 0;
      }
    }), (e, n) => N((b(), S("div", {
      ref_key: "container",
      ref: a,
      class: "ds-position-relative",
      onKeydown: [
        T,
        f(d(c, ["exact"]), ["esc"]),
        n[0] || (n[0] = f(d((t) => p("up"), ["prevent"]), ["up"])),
        n[1] || (n[1] = f(d((t) => p("down"), ["prevent"]), ["down"]))
      ]
    }, [
      A(e.$slots, "default", {
        opened: u.value,
        focusIndex: o.value,
        focus: g,
        close: c,
        open: O
      })
    ], 40, _)), [
      [K(w), E]
    ]);
  }
});
export {
  $ as default
};
